import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import RadioGroup from '../../../../../reusable/Form/RadioGroup.jsx';
import CategoryFilter from '../../../../../reusable/Dropdowns/Category.filter';
import SelectEntitiesFilter from './../../../../../reusable/Dropdowns/SelectEntities.filter'
import { ENTITIES_FILTER_CATEGORIES, ENTITIES_FILTER_ALL_ENTITIES, ENTITIES_FILTER_SPECIFIC } from "../../../../../constants";

class EntitiesFilter extends React.PureComponent {

    static propTypes = {
        entities: PropTypes.object,
        changeHandlers: PropTypes.object,
        categories: PropTypes.object,
        entitiesSelection: PropTypes.object,
        filtersState: PropTypes.string
    }

    static defaultProps = {
        entitiesSelection: null
    }

    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        let newEntities;
        switch (e.target.value) {
            case ENTITIES_FILTER_ALL_ENTITIES: {
                newEntities = {
                    type: ENTITIES_FILTER_ALL_ENTITIES,
                    entitiesId: [],
                    categories: {
                        allCategories: true,
                        allUnassigned: true,
                        categoriesId: []
                    }
                };
                break;
            }
            case ENTITIES_FILTER_SPECIFIC: {
                newEntities = {
                    type: ENTITIES_FILTER_SPECIFIC,
                    entitiesId: [],
                    categories: {
                        allCategories: true,
                        allUnassigned: true,
                        categoriesId: []
                    }
                };
                break;
            }
            case ENTITIES_FILTER_CATEGORIES: {
                newEntities = {
                    type: ENTITIES_FILTER_CATEGORIES,
                    entitiesId: [],
                    categories: {
                        allCategories: true,
                        allUnassigned: true,
                        categoriesId: []
                    }
                };
                break;
            }
            default:
                newEntities = {
                    type: ENTITIES_FILTER_ALL_ENTITIES,
                    entitiesId: [],
                    categories: {
                        allCategories: true,
                        allUnassigned: true,
                        categoriesId: []
                    }
                }
        }

        this.props.changeHandlers.entities(newEntities)
    }

    render() {
        const options = [
            {
                value: 'all_entities',
                label: <FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.selectAll"/>
            },
            {
                value: 'specific',
                label: <FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.selectBySpecific"/>,
                content: <SelectEntitiesFilter switchEntity={this.props.changeHandlers.entities} entities={this.props.entities} selectedEntities={this.props.entitiesSelection.entitiesId} />
            },
            {
                value: 'categories',
                label: <FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.selectByCategory"/>,
                content: <CategoryFilter { ...this.props } switchCategory={this.props.changeHandlers.entities} selectedCategories={this.props.entitiesSelection.categories} className="categories-filter"/>
            }
        ]
        return <RadioGroup value={this.props.entitiesSelection.type} onChange={this.onChange} fieldId={"entities-filter"} options={options} classNames="notranslate"/>
    }

}

export default injectIntl(EntitiesFilter);


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/components/FilterPod/Entities.filter.jsx